import React, { useEffect, useState } from "react";
import axios from "axios";
import Web3 from "web3";
import "./Product.css";
import AlgosignerUtility from "./../apis/AlgosignerUtility";
const eprcontract = require("../EPRCertificate_NFT.json");
function Product(props) {
  const [price, setPrice] = useState("");
  const [numNfts, setNumNfts] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [maticPrice, setMaticPrice] = useState(0);

  useEffect(() => {
    const fetchProduct = async () => {
      axios
        .get(`/api/price?id=3890&convert=USD`, {})
        .then(function (response) {
          setPrice(
            (response.data.data["3890"].quote.USD.price * 100).toFixed(2)
          );
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          // always executed
        });
    };
    fetchProduct();
  });

    // Utility to detect if the device is mobile
    const isMobile = () => {
      return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    };
  
    // Utility to detect if the device is iOS
    const isIOS = () => {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    };
  
    // Utility to detect if the device is Android
    const isAndroid = () => {
      return /Android/i.test(navigator.userAgent);
    };
  

  //Dynamic Price Calculation in Popup
  const handleNumNftsInput = (event) => {
    const numNfts = parseInt(event.target.value);
    setNumNfts(numNfts);
    if (!isNaN(numNfts)) {
      setTotalPrice((numNfts * price).toFixed(2));
      setMaticPrice((numNfts * props.nfts.nft_sale[0].fixedPrice).toFixed(2));
    } else {
      setTotalPrice("");
      setMaticPrice("");
    }
  };

  //Put code that comes after Credit here
  const handleTransactionComplete = async (txHash) => {
    const web3 = new Web3(window.ethereum);
    // await window.ethereum.enable();
    await window.ethereum.request({ method: 'eth_requestAccounts' });
    const accounts = await web3.eth.getAccounts();

    // Add your code here to execute after the transaction is completed
    
    // const EPRContractAddress = "0xbf58e2088db928f09e031dfbe2aa0e9344dc6764";
    const EPRContractAddress = "0xe4DC3879CdA3C14f2ceA57ec7b8c516b24800644";
    //const EPRContractAddress = environment.EPRContractAddress
    // let contractABI = (await ethapi.contract.getabi(EPRContractAddress)).result
    console.log("ABI: ", eprcontract.output.abi);
    console.log(window.ethereum.isConnected());
    
    const eprContract = new web3.eth.Contract(
      eprcontract.output.abi,
      EPRContractAddress
    ); //removed window from here
    console.log("Crypto received, calling smart contract now!");
    await eprContract.methods
      .transfer(
        //certnumber,
        props.nfts.certNumber,
        //From Address
        props.nfts.nft_sale[0].owner,
        //To Address
        accounts[0],
        //totalquantity,
        numNfts
        //this.EPR_PUBLIC_KEY,
        //txHash
        //event.asset.epr_hash
      )
      .send({ from: accounts[0] }) //.send() - writing data to blockchain (Metamask to Account address)
      .on("error", function (error) {
        console.error("Error occurred while transferring NFT:", error);
      })
      //Console this for error
      .then(function (receipt) {
        return receipt;
      });
  };
  //Confirm Purchase Button Click
  const handleConfirmPurchaseClick = async () => {
    try {
      // Check if MetaMask is installed
      if (typeof window.ethereum !== "undefined") {
        // Check if the network is Polygon Testnet
        const chainId = await window.ethereum.request({
          method: "eth_chainId",
        });
        // if (chainId !== "0x13881") {
          if (chainId !== "0x13882") {
          console.log("Please switch to the Polygon Testnet network");
          return;
        }

        if (isMobile()) {
          // Attempt to open MetaMask via deep link on mobile
          window.location.href = "https://metamask.app.link/dapp/" + window.location.href;

         // Redirect to the app store if MetaMask didn't open
         setTimeout(() => {
          if (isIOS()) {
            window.location.href = "https://apps.apple.com/app/metamask/id1438144202";
          } else if (isAndroid()) {
            window.location.href = "https://play.google.com/store/apps/details?id=io.metamask";
          }
        }, 1500); // 1.5-second delay before redirecting to the app store
      } else {

        await window.ethereum.request({ method: 'eth_requestAccounts' });
        // Create Web3 instance
        const web3 = new Web3(window.ethereum);
        // Get the selected account
        const accounts = await web3.eth.getAccounts();
        const from = accounts[0];
        // Set the recipient address
        //if (props.nfts !== undefined)

        const to = props.nfts.nft_sale[0].owner;

        console.log("Owner Address: " + to);
        // Check if the sender and recipient addresses are different
        if (from === to) {
          console.log("Sender and recipient addresses cannot be the same");
          return;
        }
        // Set the amount of MATIC to transfer
        // const amount = web3.utils.toWei(
        //   (numNfts * props.nfts.nft_sale[0].fixedPrice).toString(),
        //   "ether"
        // );
        const amount = web3.utils.toWei("0.00001", "ether");
        // Send the transaction
        const txHash = await web3.eth.sendTransaction({
          from,
          to,
          value: amount,
          data: "0x",
        });
        console.log("Transaction hash:", txHash);
        // Call the callback function after the transaction is completed
        //const receipt = await web3.eth.getTransactionReceipt(txHash);
        if (txHash.status) {
          alert(
            "Transfer completed! Please accept the contract call in the next step."
          );
          handleTransactionComplete(txHash.transactionHash);

          console.log("CRYPTO TRANSFER DONE");
        }
      }
      } else {
        console.log("MetaMask is not installed");
      }
    } catch (error) {
      console.error(error);
    }
  };

  //Closing modal popup
  const handleCloseModal = () => {
    setNumNfts("");
    setTotalPrice(0);
  };

  const isDisabled = numNfts === 0 || isNaN(numNfts);

  const buyWithAlgos = async() => {
    console.log("Inside buywith algo");
    try {
        const connection = await AlgosignerUtility.checkAlgoSignerWallet1(true);
        console.log("connection------",connection);

        if (!connection) {
            console.log("Inside IF");
            return;
        }   

        const paymentTransaction = await axios.post('http://40.80.90.217:5002/useralgopayment',{
            body: {
                "Sender":connection[0],
                "Receiver":"OOF7CR65VIJIKYUXRWBENSIUQVW6YHUL7M5ONCZHYFD7JBQO33EF7MCHTQ",
                "Amount":1
            }
            })
            
            console.log("paymentTxn-------", paymentTransaction); 
           

        const paymentTxnResponse = await AlgosignerUtility.signAndSendTxn(
            paymentTransaction.data.transaction
        ).then(async(paymentTxnResponse) => {
            console.log("PaymentTXNResponse---------", paymentTxnResponse);
            const tokenTransfer = await axios.post('http://40.80.90.217:5002/marketplacetokentransfer',{
                    body: {
                        "Receiver":connection[0],
                        "No_Of_Tokens" : 1,
                        "Token_ID" : 162760282
                     }        
                })
                console.log("TransferToken", tokenTransfer);

        })
        
        // })
        // console.log("TransferToken", tokenTransfer)
        // const tokenTransferResponse = await AlgosignerUtility.signAndSendTxn(
        //     tokenTransfer.data.transaction
        // );
        // console.log("tokenTransferResponse---", tokenTransferResponse)
    } catch (err) {
        console.log(err.message);
    }
};


  //console.log("nft",props.nfts);
  return (
    <div>
      <div className="row">
        <div className="col-5 px-5">
          <img className="img-product" src="{props.image}" alt="nft"></img>
        </div>
        <div className="col-7 px-5 py-4">
          <div className="">
            <h2 className="h2productcard" style={{ "font-weight": "bold" }}>
              {props.nfts !== undefined ? (
                props.nfts.assetId
              ) : (
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              )}
            </h2>
            <p
              className="my-4 d-inline-block fs-5"
              style={{ "font-weight": "bold" }}
            >
              Owned by{" "}
              {props.nfts !== undefined ? (
                props.nfts.nft_sale[0].ownerName
              ) : (
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              )}
            </p>
            <p className="ms-4 d-inline-block">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="20"
                fill="currentColor"
                class="bi bi-box-seam"
                viewBox="0 0 20 20"
              >
                <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2l-2.218-.887zm3.564 1.426L5.596 5 8 5.961 14.154 3.5l-2.404-.961zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
              </svg>
            </p>
            <p className="ms-2 d-inline-block">
              {props.nfts !== undefined ? (
                props.nfts.no_of_copies
              ) : (
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              )}
              &nbsp; Copies
            </p>
          </div>
          <div className="card1 py-0 px-2">
            <div className="card-body">
              <p className="fs-4 text-secondary">Current Price</p>
              <div>
                <h2 className="d-inline-block">
                  {props.nfts !== undefined ? (
                    props.nfts.nft_sale[0].fixedPrice
                  ) : (
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  )}{" "}
                  MATIC
                </h2>
                <p className="d-inline-block ms-2">${price}</p>
              </div>
              <div className="my-3 row">
                {/* <div className="col-6">
                  <button className="button" disabled>
                    ADD TO CART
                  </button>
                </div> */}
                <div className="col-6">
                  <button
                    className="buttonbuy"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    BUY NOW
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="my-5">
            <h2 className="mb-3 fontdescription">
              Description
            </h2>
            <p>{props.description}</p>
          </div>
        </div>
      </div>

      <div
        className="modal"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Buy NFTs
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="numNftsInput">Number of NFTs</label>
                <input
                  type="number"
                  className="form-control"
                  id="numNftsInput"
                  value={numNfts}
                  onChange={handleNumNftsInput}
                  min="1"
                  max="10"
                />
              </div>
              <p>Total Price: {totalPrice} USD</p>
              <p>Price in Matic: {maticPrice} MATIC</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="buttonclosemodal"
                data-bs-dismiss="modal">
                Cancel
              </button>
              <button
                type="button"
                className="buttonconfirmprod"
                onClick={handleConfirmPurchaseClick}
                // onClick={buyWithAlgos}
                disabled={isDisabled}
              >
                Confirm Purchase
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Product;
